module.exports = __webpack_public_path__ + "media/Nature of strength (Chivalry).8d2b10e3.mp3";